import { LayoutNames, NewUiZoneWidgetConfig } from '@finxone-platform/shared/sys-config-types';

export class DroppedWidgetIntoLayoutWidgetAction {
  static readonly type = '[AppGrid] DroppedWidgetIntoLayoutWidgetAction';
  constructor(
    public widgetDroppedInto: NewUiZoneWidgetConfig,
    public widgetLayoutType?: LayoutNames,
    public target2dChildComponentIndex?: number,
  ) {}
}
